import React from 'react';

import SvgContainer from '../SvgContainer';

const PointerLeft = () => {
    return (
        <SvgContainer>
            <path d="M5.09934 12.553C5.38454 12.8076 5.81546 12.8076 6.10066 12.553C6.43517 12.2543 6.43545 11.7311 6.10127 11.4321L3.064 8.71429H15.2857C15.6802 8.71429 16 8.39449 16 8C16 7.60551 15.6802 7.28571 15.2857 7.28571H3.064L6.1039 4.57152C6.44042 4.27105 6.4395 3.74428 6.10192 3.44499C5.81574 3.19127 5.38493 3.19203 5.09964 3.44675L0.835451 7.25406C0.390138 7.65166 0.390138 8.34834 0.83545 8.74594L5.09934 12.553Z" />
        </SvgContainer>
    );
};

export default PointerLeft;
